var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
export class EntityObservables {
    // lazy observable creation
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get entity() {
        return this.parent;
    }
    createdAt;
    updatedAt;
    accessedAt;
    document_version = 1;
}
__decorate([
    observable.ref
], EntityObservables.prototype, "createdAt", void 0);
__decorate([
    observable.ref
], EntityObservables.prototype, "updatedAt", void 0);
__decorate([
    observable.ref
], EntityObservables.prototype, "accessedAt", void 0);
__decorate([
    observable
], EntityObservables.prototype, "document_version", void 0);
